var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CourseSeting"},[(_vm.queryName == '基本设置')?_c('BaseSet'):_vm._e(),(_vm.queryName == '课时列表')?_c('CourseChildren'):_vm._e(),(_vm.queryName == '课程报告')?_c('Report'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }